import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { RoutesPaths } from "../../Router/constant";
import { logout, toggleMobileMenu } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import Confirm from "../confirm/confrm";
import { getUnreadChatAction } from "../../actions/chatv2";

export default function Sidebar() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const { sidebarMobile, showMenuSidebar } = useSelector((state) => state.auth);
  const { unreadCount } = useSelector((state) => state.chatv2);

  const [confirmModal, setConfirmModal] = useState(false);

  const dashboardPath = useLocation(RoutesPaths.DASHBOARD);
  const subscriptionPath = useLocation(RoutesPaths.SUBSCRIPTION);
  const suggestedProfilePath = useLocation(RoutesPaths.BOOK_OF_BUSINESS);
  const businessDetailPath = useLocation(RoutesPaths.BUSINESSDETAIL);
  const AdvisorDetailPath = useLocation(RoutesPaths.ADVISORBUSINESSDETAIL);
  const notificationPath = useLocation(RoutesPaths.NOTIFICATIONMANAGER);
  const objectivePath = useLocation(RoutesPaths.OBJECTIVE);
  const paymentPath = useLocation(RoutesPaths.PAYMENT);
  const invitePath = useLocation(RoutesPaths.INVITE);
  const filePath = useLocation(RoutesPaths.FILE);
  const taskPath = useLocation(RoutesPaths.TASK);
  const MessagePath = useLocation(RoutesPaths.MESSAGE_DETAIL);
  const bannerPath = useLocation(RoutesPaths.BANNER);
  const userPath = useLocation(RoutesPaths.USER_MANAGER);
  const campaignPath = useLocation(RoutesPaths.CAMPAIGN_MANAGER);
  const payoutPath = useLocation(RoutesPaths.PAYOUT_MANAGER);
  const paidUpPath = useLocation(RoutesPaths.PAIDUP);
  const todoPath = useLocation(RoutesPaths.TODOLIST);
  const activationAnalyticsPath = useLocation(RoutesPaths.ACTIVATION_ANALYTICS);

  useEffect(() => {
    if (sidebarMobile) {
      document.body.classList.add("g-sidenav-pinned");
    } else {
      document.body.classList.remove("g-sidenav-pinned");
    }
  }, [sidebarMobile]);

  const logoutClick = () => {
    setConfirmModal(true);
  };

  const logoutHide = (value) => {
    if (value) {
      dispatch(logout());
    }
    setConfirmModal(false);
  };

  const mobileMenuOpen = () => {
    dispatch(toggleMobileMenu());
  };

  const logoActionHeader = () => {
    navigate("/dashboard");
  }

  useEffect(() => {
    dispatch(getUnreadChatAction())
  }, [dispatch, location])


  return (
    <aside
      // bg-white
      className={`sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 custom-scroll ${sidebarMobile ? "bg-white" : ""
        }`}
      id="sidenav-main"
    >
      <div className="sidenav-header">
        <i
          className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-xl-none icon"
          aria-hidden="true"
          onClick={mobileMenuOpen}
        ></i>
        <div onClick={logoActionHeader} className="navbar-brand m-0">
          <div className="navbar-header-icon admin-nav active">
            <img src="assets/img/logo.png" className="normal-icon" alt="" />
          </div>
          <p className="navbar-title">Admin</p>
        </div>
      </div>
      <hr className="horizontal dark mt-0" />
      {showMenuSidebar && (
        <div
          className="collapse navbar-collapse w-auto display-account ps"
          id="sidenav-collapse-main"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink
                active={dashboardPath?.isExact}
                to={RoutesPaths.DASHBOARD}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/dashboard-icon.svg"
                    className="active-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/dashboard-icon.svg"
                    className="normal-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Dashboard</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={suggestedProfilePath?.isExact}
                to={RoutesPaths.BOOK_OF_BUSINESS}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fa-solid fa-address-card"></i>
                </div>
                <span className="nav-link-text ms-1">Book of business</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={subscriptionPath?.isExact}
                to={RoutesPaths.SUBSCRIPTION}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-coins"></i>
                </div>
                <span className="nav-link-text ms-1">Subscription plans</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={businessDetailPath?.isExact}
                to={RoutesPaths.BUSINESSDETAIL}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/businessDetail-active.svg"
                    className="normal-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/businessDetail-active.svg"
                    className="active-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Business details</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={AdvisorDetailPath?.isExact}
                to={RoutesPaths.ADVISORBUSINESSDETAIL}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/businessDetail-active.svg"
                    className="normal-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/businessDetail-active.svg"
                    className="active-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Advisors</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={notificationPath?.isExact}
                to={RoutesPaths.NOTIFICATIONMANAGER}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/notify-active.svg"
                    className="normal-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/notify-active.svg"
                    className="active-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Notifications manager</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={objectivePath?.isExact}
                to={RoutesPaths.OBJECTIVE}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/objective-active.svg"
                    className="normal-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/objective-active.svg"
                    className="active-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Objectives manager</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={bannerPath?.isExact}
                to={RoutesPaths.BANNER}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/banner-active.svg"
                    className="normal-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/banner-active.svg"
                    className="active-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Banner</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={invitePath?.isExact}
                to={RoutesPaths.INVITE}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-list"></i>
                </div>
                <span className="nav-link-text ms-1">Request logs</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={paymentPath?.isExact}
                to={RoutesPaths.PAYMENT}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-wallet"></i>
                </div>
                <span className="nav-link-text ms-1">Payments</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={paymentPath?.isExact}
                to={RoutesPaths.REFERRAL_INVITES}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-wallet"></i>
                </div>
                <span className="nav-link-text ms-1">Invites</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={campaignPath?.isExact}
                to={RoutesPaths.CAMPAIGN_MANAGER}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 16 17" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6008 0.420896C12.5124 0.471018 12.4236 0.616099 12.0776 1.27577C11.6152 2.15717 11.5979 2.21714 11.7504 2.40571C11.869 2.55235 12.057 2.56412 12.1723 2.43217C12.2983 2.28806 13.0355 0.83797 13.0355 0.734271C13.0355 0.586876 12.9735 0.472158 12.8623 0.413849C12.7351 0.347181 12.7304 0.347319 12.6008 0.420896ZM7.97041 0.617066C7.54363 0.748261 7.20471 1.09929 7.06182 1.55809C6.99507 1.77253 6.97991 2.1961 7.03187 2.39625C7.05995 2.5044 7.04438 2.55604 6.84972 3.00051C6.18641 4.51519 5.06071 6.00196 3.58318 7.31495C3.29794 7.56839 3.29025 7.5726 3.14714 7.55478C3.00504 7.53709 2.97981 7.55043 2.11703 8.09939C1.08109 8.75854 0.918635 8.87934 0.665006 9.17886C-0.484923 10.537 -0.0915977 12.7286 1.44462 13.5228C1.80978 13.7116 2.11402 13.7739 2.5757 13.7544C3.02383 13.7355 3.3303 13.6499 3.6484 13.455L3.81305 13.354L4.11923 13.7918C4.28763 14.0325 4.72185 14.6569 5.08419 15.1794C5.4465 15.7018 5.76982 16.1559 5.80262 16.1885C5.98775 16.372 6.358 16.4211 6.59496 16.2935C6.67247 16.2518 6.9003 16.0423 7.10128 15.828C7.39287 15.5171 7.47328 15.4105 7.49949 15.3003C7.55317 15.0745 7.53963 14.8604 7.46106 14.693C7.42163 14.609 6.99223 13.9652 6.50682 13.2622L5.62425 11.9841L5.75772 11.9213C5.83117 11.8867 6.10693 11.7736 6.3706 11.6699C7.77897 11.116 9.06503 10.8509 10.331 10.8533C11.2061 10.8551 11.3991 10.8856 11.5731 11.0502C11.6466 11.1197 11.7979 11.2261 11.9093 11.2867C12.1 11.3904 12.1321 11.3969 12.4571 11.3969C12.7847 11.3969 12.813 11.3911 13.0125 11.2826C13.5471 10.9918 13.8595 10.34 13.7575 9.7283C13.7107 9.44792 13.676 9.37323 12.9136 7.91434C12.5679 7.25287 12.2855 6.70105 12.2859 6.68806C12.2863 6.6751 12.3438 6.61787 12.4137 6.56087C12.5674 6.43565 12.7276 6.20159 12.8309 5.95146C13.1534 5.16996 12.8293 4.20216 12.1205 3.83027C11.7495 3.63565 11.2761 3.61389 10.9343 3.77576L10.7878 3.84512L10.0904 2.51262C9.70686 1.77972 9.34183 1.11615 9.27927 1.03794C8.97777 0.661144 8.41533 0.480276 7.97041 0.617066ZM8.00187 1.35073C7.75543 1.49097 7.64762 1.67429 7.63202 1.97976C7.62217 2.17196 7.63271 2.24201 7.69018 2.36688C7.80195 2.60976 11.8505 10.3504 11.9209 10.4558C12.0161 10.5984 12.2668 10.7235 12.4554 10.7226C12.9066 10.7204 13.2484 10.2318 13.1216 9.77034C13.0662 9.56861 8.92237 1.62956 8.80027 1.49118C8.67762 1.35221 8.54611 1.28762 8.34836 1.26924C8.2005 1.25549 8.14722 1.268 8.00187 1.35073ZM13.9266 3.33109C13.2507 3.76239 13.098 3.89269 13.098 4.03815C13.098 4.24043 13.2439 4.40192 13.4267 4.40192C13.5157 4.40192 14.7866 3.60912 14.9036 3.48059C14.9532 3.42618 14.974 3.36249 14.974 3.26549C14.974 3.07882 14.8741 2.95253 14.7082 2.92949C14.5932 2.91349 14.5305 2.94569 13.9266 3.33109ZM7.3193 3.52449C6.6962 4.92055 5.37472 6.63282 3.99489 7.83206C3.79379 8.00685 3.62814 8.16232 3.62683 8.17752C3.62448 8.20499 5.23552 11.3045 5.27742 11.3531C5.28942 11.3671 5.47464 11.303 5.68903 11.2109C7.34444 10.499 8.85708 10.1584 10.3694 10.1569C11.0301 10.1563 11.0329 10.1559 10.9924 10.0857C10.97 10.0469 10.1733 8.52292 9.22199 6.69904C8.27063 4.87516 7.47622 3.36349 7.45665 3.33972C7.42914 3.30639 7.3979 3.34839 7.3193 3.52449ZM11.3418 4.37128C11.0715 4.41595 11.0641 4.37812 11.5094 5.23096C11.7325 5.65843 11.928 6.02293 11.9437 6.04093C11.9857 6.08894 12.1767 5.87077 12.2571 5.68299C12.3503 5.46509 12.3507 5.12391 12.2579 4.91213C12.0868 4.52151 11.725 4.30793 11.3418 4.37128ZM14.0679 6.064C13.9475 6.11709 13.8826 6.19755 13.8619 6.31962C13.8401 6.44822 13.9092 6.62529 14.003 6.68073C14.0402 6.7027 14.3981 6.71631 14.9389 6.71631C15.8023 6.71631 15.8158 6.71521 15.8956 6.63859C16.0025 6.53603 16.033 6.33561 15.9604 6.21323C15.8591 6.04234 15.7632 6.02524 14.9203 6.02763C14.4876 6.02887 14.1112 6.04493 14.0679 6.064ZM2.15495 8.87122C1.51678 9.28069 1.35229 9.40273 1.16939 9.6026C0.592501 10.2329 0.463341 11.1998 0.847474 12.0123C1.06599 12.4744 1.54958 12.8872 2.03273 13.024C2.30659 13.1015 2.82151 13.0771 3.0773 12.9745C3.28143 12.8926 4.81255 11.9356 4.81255 11.8899C4.81255 11.8272 2.98722 8.37459 2.95539 8.37708C2.93644 8.37853 2.57626 8.60092 2.15495 8.87122ZM4.77369 12.7361C4.55514 12.8735 4.37605 12.9937 4.37571 13.0032C4.37471 13.0309 6.19057 15.6431 6.23031 15.6711C6.25016 15.6851 6.27658 15.6967 6.28899 15.697C6.33733 15.6981 6.90737 15.0964 6.90718 15.0445C6.907 15.0003 5.34342 12.6856 5.20785 12.5289C5.17899 12.4955 5.08541 12.5402 4.77369 12.7361Z" fill="#ffffff" />
                    <path d="M7.3193 3.52449C6.6962 4.92055 5.37472 6.63282 3.99489 7.83206C3.79379 8.00685 3.62814 8.16232 3.62683 8.17752C3.62448 8.20499 5.23552 11.3045 5.27742 11.3531C5.28942 11.3671 5.47464 11.303 5.68903 11.2109C7.34444 10.499 8.85708 10.1584 10.3694 10.1569C11.0301 10.1563 11.0329 10.1559 10.9924 10.0857C10.97 10.0469 10.1733 8.52292 9.22199 6.69904C8.27063 4.87516 7.47622 3.36349 7.45665 3.33972C7.42914 3.30639 7.3979 3.34839 7.3193 3.52449Z" fill="#ffffff" />
                  </svg>
                </div>
                <span className="nav-link-text ms-1">Campaigns</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={payoutPath?.isExact}
                to={RoutesPaths.PAYOUT_MANAGER}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 16 17" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6008 0.420896C12.5124 0.471018 12.4236 0.616099 12.0776 1.27577C11.6152 2.15717 11.5979 2.21714 11.7504 2.40571C11.869 2.55235 12.057 2.56412 12.1723 2.43217C12.2983 2.28806 13.0355 0.83797 13.0355 0.734271C13.0355 0.586876 12.9735 0.472158 12.8623 0.413849C12.7351 0.347181 12.7304 0.347319 12.6008 0.420896ZM7.97041 0.617066C7.54363 0.748261 7.20471 1.09929 7.06182 1.55809C6.99507 1.77253 6.97991 2.1961 7.03187 2.39625C7.05995 2.5044 7.04438 2.55604 6.84972 3.00051C6.18641 4.51519 5.06071 6.00196 3.58318 7.31495C3.29794 7.56839 3.29025 7.5726 3.14714 7.55478C3.00504 7.53709 2.97981 7.55043 2.11703 8.09939C1.08109 8.75854 0.918635 8.87934 0.665006 9.17886C-0.484923 10.537 -0.0915977 12.7286 1.44462 13.5228C1.80978 13.7116 2.11402 13.7739 2.5757 13.7544C3.02383 13.7355 3.3303 13.6499 3.6484 13.455L3.81305 13.354L4.11923 13.7918C4.28763 14.0325 4.72185 14.6569 5.08419 15.1794C5.4465 15.7018 5.76982 16.1559 5.80262 16.1885C5.98775 16.372 6.358 16.4211 6.59496 16.2935C6.67247 16.2518 6.9003 16.0423 7.10128 15.828C7.39287 15.5171 7.47328 15.4105 7.49949 15.3003C7.55317 15.0745 7.53963 14.8604 7.46106 14.693C7.42163 14.609 6.99223 13.9652 6.50682 13.2622L5.62425 11.9841L5.75772 11.9213C5.83117 11.8867 6.10693 11.7736 6.3706 11.6699C7.77897 11.116 9.06503 10.8509 10.331 10.8533C11.2061 10.8551 11.3991 10.8856 11.5731 11.0502C11.6466 11.1197 11.7979 11.2261 11.9093 11.2867C12.1 11.3904 12.1321 11.3969 12.4571 11.3969C12.7847 11.3969 12.813 11.3911 13.0125 11.2826C13.5471 10.9918 13.8595 10.34 13.7575 9.7283C13.7107 9.44792 13.676 9.37323 12.9136 7.91434C12.5679 7.25287 12.2855 6.70105 12.2859 6.68806C12.2863 6.6751 12.3438 6.61787 12.4137 6.56087C12.5674 6.43565 12.7276 6.20159 12.8309 5.95146C13.1534 5.16996 12.8293 4.20216 12.1205 3.83027C11.7495 3.63565 11.2761 3.61389 10.9343 3.77576L10.7878 3.84512L10.0904 2.51262C9.70686 1.77972 9.34183 1.11615 9.27927 1.03794C8.97777 0.661144 8.41533 0.480276 7.97041 0.617066ZM8.00187 1.35073C7.75543 1.49097 7.64762 1.67429 7.63202 1.97976C7.62217 2.17196 7.63271 2.24201 7.69018 2.36688C7.80195 2.60976 11.8505 10.3504 11.9209 10.4558C12.0161 10.5984 12.2668 10.7235 12.4554 10.7226C12.9066 10.7204 13.2484 10.2318 13.1216 9.77034C13.0662 9.56861 8.92237 1.62956 8.80027 1.49118C8.67762 1.35221 8.54611 1.28762 8.34836 1.26924C8.2005 1.25549 8.14722 1.268 8.00187 1.35073ZM13.9266 3.33109C13.2507 3.76239 13.098 3.89269 13.098 4.03815C13.098 4.24043 13.2439 4.40192 13.4267 4.40192C13.5157 4.40192 14.7866 3.60912 14.9036 3.48059C14.9532 3.42618 14.974 3.36249 14.974 3.26549C14.974 3.07882 14.8741 2.95253 14.7082 2.92949C14.5932 2.91349 14.5305 2.94569 13.9266 3.33109ZM7.3193 3.52449C6.6962 4.92055 5.37472 6.63282 3.99489 7.83206C3.79379 8.00685 3.62814 8.16232 3.62683 8.17752C3.62448 8.20499 5.23552 11.3045 5.27742 11.3531C5.28942 11.3671 5.47464 11.303 5.68903 11.2109C7.34444 10.499 8.85708 10.1584 10.3694 10.1569C11.0301 10.1563 11.0329 10.1559 10.9924 10.0857C10.97 10.0469 10.1733 8.52292 9.22199 6.69904C8.27063 4.87516 7.47622 3.36349 7.45665 3.33972C7.42914 3.30639 7.3979 3.34839 7.3193 3.52449ZM11.3418 4.37128C11.0715 4.41595 11.0641 4.37812 11.5094 5.23096C11.7325 5.65843 11.928 6.02293 11.9437 6.04093C11.9857 6.08894 12.1767 5.87077 12.2571 5.68299C12.3503 5.46509 12.3507 5.12391 12.2579 4.91213C12.0868 4.52151 11.725 4.30793 11.3418 4.37128ZM14.0679 6.064C13.9475 6.11709 13.8826 6.19755 13.8619 6.31962C13.8401 6.44822 13.9092 6.62529 14.003 6.68073C14.0402 6.7027 14.3981 6.71631 14.9389 6.71631C15.8023 6.71631 15.8158 6.71521 15.8956 6.63859C16.0025 6.53603 16.033 6.33561 15.9604 6.21323C15.8591 6.04234 15.7632 6.02524 14.9203 6.02763C14.4876 6.02887 14.1112 6.04493 14.0679 6.064ZM2.15495 8.87122C1.51678 9.28069 1.35229 9.40273 1.16939 9.6026C0.592501 10.2329 0.463341 11.1998 0.847474 12.0123C1.06599 12.4744 1.54958 12.8872 2.03273 13.024C2.30659 13.1015 2.82151 13.0771 3.0773 12.9745C3.28143 12.8926 4.81255 11.9356 4.81255 11.8899C4.81255 11.8272 2.98722 8.37459 2.95539 8.37708C2.93644 8.37853 2.57626 8.60092 2.15495 8.87122ZM4.77369 12.7361C4.55514 12.8735 4.37605 12.9937 4.37571 13.0032C4.37471 13.0309 6.19057 15.6431 6.23031 15.6711C6.25016 15.6851 6.27658 15.6967 6.28899 15.697C6.33733 15.6981 6.90737 15.0964 6.90718 15.0445C6.907 15.0003 5.34342 12.6856 5.20785 12.5289C5.17899 12.4955 5.08541 12.5402 4.77369 12.7361Z" fill="#ffffff" />
                    <path d="M7.3193 3.52449C6.6962 4.92055 5.37472 6.63282 3.99489 7.83206C3.79379 8.00685 3.62814 8.16232 3.62683 8.17752C3.62448 8.20499 5.23552 11.3045 5.27742 11.3531C5.28942 11.3671 5.47464 11.303 5.68903 11.2109C7.34444 10.499 8.85708 10.1584 10.3694 10.1569C11.0301 10.1563 11.0329 10.1559 10.9924 10.0857C10.97 10.0469 10.1733 8.52292 9.22199 6.69904C8.27063 4.87516 7.47622 3.36349 7.45665 3.33972C7.42914 3.30639 7.3979 3.34839 7.3193 3.52449Z" fill="#ffffff" />
                  </svg>
                </div>
                <span className="nav-link-text ms-1">Payouts</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={paidUpPath?.isExact}
                to={RoutesPaths.PAIDUP}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-building-columns"></i>
                </div>
                <span className="nav-link-text ms-1">Paid Up</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={todoPath?.isExact}
                to={RoutesPaths.TODOLIST}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 16 17" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6008 0.420896C12.5124 0.471018 12.4236 0.616099 12.0776 1.27577C11.6152 2.15717 11.5979 2.21714 11.7504 2.40571C11.869 2.55235 12.057 2.56412 12.1723 2.43217C12.2983 2.28806 13.0355 0.83797 13.0355 0.734271C13.0355 0.586876 12.9735 0.472158 12.8623 0.413849C12.7351 0.347181 12.7304 0.347319 12.6008 0.420896ZM7.97041 0.617066C7.54363 0.748261 7.20471 1.09929 7.06182 1.55809C6.99507 1.77253 6.97991 2.1961 7.03187 2.39625C7.05995 2.5044 7.04438 2.55604 6.84972 3.00051C6.18641 4.51519 5.06071 6.00196 3.58318 7.31495C3.29794 7.56839 3.29025 7.5726 3.14714 7.55478C3.00504 7.53709 2.97981 7.55043 2.11703 8.09939C1.08109 8.75854 0.918635 8.87934 0.665006 9.17886C-0.484923 10.537 -0.0915977 12.7286 1.44462 13.5228C1.80978 13.7116 2.11402 13.7739 2.5757 13.7544C3.02383 13.7355 3.3303 13.6499 3.6484 13.455L3.81305 13.354L4.11923 13.7918C4.28763 14.0325 4.72185 14.6569 5.08419 15.1794C5.4465 15.7018 5.76982 16.1559 5.80262 16.1885C5.98775 16.372 6.358 16.4211 6.59496 16.2935C6.67247 16.2518 6.9003 16.0423 7.10128 15.828C7.39287 15.5171 7.47328 15.4105 7.49949 15.3003C7.55317 15.0745 7.53963 14.8604 7.46106 14.693C7.42163 14.609 6.99223 13.9652 6.50682 13.2622L5.62425 11.9841L5.75772 11.9213C5.83117 11.8867 6.10693 11.7736 6.3706 11.6699C7.77897 11.116 9.06503 10.8509 10.331 10.8533C11.2061 10.8551 11.3991 10.8856 11.5731 11.0502C11.6466 11.1197 11.7979 11.2261 11.9093 11.2867C12.1 11.3904 12.1321 11.3969 12.4571 11.3969C12.7847 11.3969 12.813 11.3911 13.0125 11.2826C13.5471 10.9918 13.8595 10.34 13.7575 9.7283C13.7107 9.44792 13.676 9.37323 12.9136 7.91434C12.5679 7.25287 12.2855 6.70105 12.2859 6.68806C12.2863 6.6751 12.3438 6.61787 12.4137 6.56087C12.5674 6.43565 12.7276 6.20159 12.8309 5.95146C13.1534 5.16996 12.8293 4.20216 12.1205 3.83027C11.7495 3.63565 11.2761 3.61389 10.9343 3.77576L10.7878 3.84512L10.0904 2.51262C9.70686 1.77972 9.34183 1.11615 9.27927 1.03794C8.97777 0.661144 8.41533 0.480276 7.97041 0.617066ZM8.00187 1.35073C7.75543 1.49097 7.64762 1.67429 7.63202 1.97976C7.62217 2.17196 7.63271 2.24201 7.69018 2.36688C7.80195 2.60976 11.8505 10.3504 11.9209 10.4558C12.0161 10.5984 12.2668 10.7235 12.4554 10.7226C12.9066 10.7204 13.2484 10.2318 13.1216 9.77034C13.0662 9.56861 8.92237 1.62956 8.80027 1.49118C8.67762 1.35221 8.54611 1.28762 8.34836 1.26924C8.2005 1.25549 8.14722 1.268 8.00187 1.35073ZM13.9266 3.33109C13.2507 3.76239 13.098 3.89269 13.098 4.03815C13.098 4.24043 13.2439 4.40192 13.4267 4.40192C13.5157 4.40192 14.7866 3.60912 14.9036 3.48059C14.9532 3.42618 14.974 3.36249 14.974 3.26549C14.974 3.07882 14.8741 2.95253 14.7082 2.92949C14.5932 2.91349 14.5305 2.94569 13.9266 3.33109ZM7.3193 3.52449C6.6962 4.92055 5.37472 6.63282 3.99489 7.83206C3.79379 8.00685 3.62814 8.16232 3.62683 8.17752C3.62448 8.20499 5.23552 11.3045 5.27742 11.3531C5.28942 11.3671 5.47464 11.303 5.68903 11.2109C7.34444 10.499 8.85708 10.1584 10.3694 10.1569C11.0301 10.1563 11.0329 10.1559 10.9924 10.0857C10.97 10.0469 10.1733 8.52292 9.22199 6.69904C8.27063 4.87516 7.47622 3.36349 7.45665 3.33972C7.42914 3.30639 7.3979 3.34839 7.3193 3.52449ZM11.3418 4.37128C11.0715 4.41595 11.0641 4.37812 11.5094 5.23096C11.7325 5.65843 11.928 6.02293 11.9437 6.04093C11.9857 6.08894 12.1767 5.87077 12.2571 5.68299C12.3503 5.46509 12.3507 5.12391 12.2579 4.91213C12.0868 4.52151 11.725 4.30793 11.3418 4.37128ZM14.0679 6.064C13.9475 6.11709 13.8826 6.19755 13.8619 6.31962C13.8401 6.44822 13.9092 6.62529 14.003 6.68073C14.0402 6.7027 14.3981 6.71631 14.9389 6.71631C15.8023 6.71631 15.8158 6.71521 15.8956 6.63859C16.0025 6.53603 16.033 6.33561 15.9604 6.21323C15.8591 6.04234 15.7632 6.02524 14.9203 6.02763C14.4876 6.02887 14.1112 6.04493 14.0679 6.064ZM2.15495 8.87122C1.51678 9.28069 1.35229 9.40273 1.16939 9.6026C0.592501 10.2329 0.463341 11.1998 0.847474 12.0123C1.06599 12.4744 1.54958 12.8872 2.03273 13.024C2.30659 13.1015 2.82151 13.0771 3.0773 12.9745C3.28143 12.8926 4.81255 11.9356 4.81255 11.8899C4.81255 11.8272 2.98722 8.37459 2.95539 8.37708C2.93644 8.37853 2.57626 8.60092 2.15495 8.87122ZM4.77369 12.7361C4.55514 12.8735 4.37605 12.9937 4.37571 13.0032C4.37471 13.0309 6.19057 15.6431 6.23031 15.6711C6.25016 15.6851 6.27658 15.6967 6.28899 15.697C6.33733 15.6981 6.90737 15.0964 6.90718 15.0445C6.907 15.0003 5.34342 12.6856 5.20785 12.5289C5.17899 12.4955 5.08541 12.5402 4.77369 12.7361Z" fill="#ffffff" />
                    <path d="M7.3193 3.52449C6.6962 4.92055 5.37472 6.63282 3.99489 7.83206C3.79379 8.00685 3.62814 8.16232 3.62683 8.17752C3.62448 8.20499 5.23552 11.3045 5.27742 11.3531C5.28942 11.3671 5.47464 11.303 5.68903 11.2109C7.34444 10.499 8.85708 10.1584 10.3694 10.1569C11.0301 10.1563 11.0329 10.1559 10.9924 10.0857C10.97 10.0469 10.1733 8.52292 9.22199 6.69904C8.27063 4.87516 7.47622 3.36349 7.45665 3.33972C7.42914 3.30639 7.3979 3.34839 7.3193 3.52449Z" fill="#ffffff" />
                  </svg>
                </div>
                <span className="nav-link-text ms-1">Todo</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={activationAnalyticsPath?.isExact}
                to={RoutesPaths.ACTIVATION_ANALYTICS}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-chart-line"></i>
                </div>
                <span className="nav-link-text ms-1">Activation analytics</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={filePath?.isExact}
                to={RoutesPaths.FILE}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-file"></i>
                </div>
                <span className="nav-link-text ms-1">Documents</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={taskPath?.isExact}
                to={RoutesPaths.TASK}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-check-circle"></i>
                </div>
                <span className="nav-link-text ms-1">Tasks</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                active={userPath?.isExact}
                to={RoutesPaths.USER_MANAGER}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-user"></i>
                </div>
                <span className="nav-link-text ms-1">Users</span>
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                active={termsAndPrivacyPath?.isExact}
                to={RoutesPaths.TERMSANDPRIVACY}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <img
                    src="assets/img/objective-active.svg"
                    className="normal-icon"
                    alt=""
                  />
                  <img
                    src="assets/img/objective-active.svg"
                    className="active-icon"
                    alt=""
                  />
                </div>
                <span className="nav-link-text ms-1">Terms and privacy</span>
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                active={MessagePath?.isExact}
                to={RoutesPaths.MESSAGE_DETAIL}
                className="nav-link"
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-solid fa-wallet"></i>
                </div>
                <span className="nav-link-text ms-1">Message</span>
                {unreadCount > 0 &&
                  <div className="notification-container">
                    <span className="notification-badge">{unreadCount > 5 ? "5+" : unreadCount}</span>
                  </div>
                }
              </NavLink>
            </li>
          </ul>
          <span className="sidebar-account mt-3 mb-2">SUPPORT </span>
          <ul className="navbar-nav">
            <li className="nav-item" onClick={logoutClick}>
              <a className="nav-link" href="#">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-power-off"></i>
                </div>

                <span className="nav-link-text ms-1 logout-icon">Log out</span>
              </a>
            </li>
          </ul>
        </div>
      )}
      <Confirm show={confirmModal} onHide={logoutHide} />
    </aside>
  );
}
